module.exports = __webpack_public_path__ + "static/media/extra_words_ic.b3f200a6.svg";